import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-89" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-90" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-91" data-mp="4njnu5x67n8v">
          🌸 SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" data-id="element-92" data-mp="nc858hwg3afw">
          Master Korean in 60 minutes with a visual method
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px"
      }} data-id="element-93" data-mp="382p5xe0y1flo">
          LEARN TO READ HANGUL EASILY AND SIMPLY
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-md" data-id="element-94" data-mp="3o6kd5bieo01y">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-95" data-mp="30hrfnam4xk58" />
          <img src="https://cdn.magicpatterns.com/uploads/3Jw3Dizj1fmYxL1J2jNAuY/ChatGPT_Image_27_ago_2026,_17_17_14.png" alt="The K-Smart Visual System — ebook plus 5 bonuses in digital format" width={1248} height={1248} className="animate-floaty mx-auto aspect-square w-full max-w-full rounded-2xl object-contain" data-id="element-96" data-mp="35a2gqgsm3bzd" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-97" data-mp="2lkimcbd9u6av">
          ⭐ 4.9 (500+ satisfied students) · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-98" data-mp="ibgod1p0rxne">
          <CTAButton href="#value" data-id="element-99" data-mp="i9voqxnuloio">See the offer</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-100" data-mp="degiorw30wwt">
            Start understanding Korean from zero, even if you have never studied languages before.
            Learn Hangul, real phrases, essential vocabulary and K-Drama / K-Pop expressions with a
            visual, simple and organized method.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-101" data-mp="x14npxdn4m8h">
            Hangul · Pronunciation · Vocabulary · K-Drama Phrases · 30-Day Routine
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-102" data-mp="1xb5ped03cpfl">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-103" data-mp="269hc43xu732r">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-104" data-mp="2fzsugvi9pet6" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-105" data-mp="2kyduattlxwh3">
            Ebook + 5 bonuses · 120+ pages — Everything you need in one place.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-106" data-mp="2oyo28c0ymwyl">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-107" data-mp="uou3jav21yby">
              <Icon className="h-4 w-4 text-grape" data-id="element-108" data-mp="zm2kj84gvwbm" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-109" data-mp="49je886ectnp">
          🔥 Limited-time offer · Then the price goes back up to $129
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-110" data-mp="3csqxvxh7uid9">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-111" data-mp="3rheorqg4a3wv" />
          25 people are watching this product right now
        </p>
      </div>
    </header>;
}